import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { getSmsTemplateFormInputs } from "../model/sms-template.modal";
import { menuUrl } from "../sms-template-list/model/sms-template-list.constants";
import { createSmsTemplateApi } from "./sms-template-create.component.service";
import SmsTemplateCreateTemplateComponent from "./sms-template-create-template.component";
const {
  ALERT_TYPES: { SUCCESS, ERROR },
  SMS_TEMPLATE_ALERTS: { CREATE_ALERT },
} = MESSAGES;

const SmsTemplateCreateComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSmsTemplateSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct sms template payload
    let smsTemplatePayload = {};
    for (let i = 0; i < values.length; i++) {
      smsTemplatePayload[values[i].name] = values[i].value;
    }

    // INFO : call create api
    const smsTemplateResponse = await createSmsTemplateApi(smsTemplatePayload);

    // INFO : check api response and show relevant alert message
    if (smsTemplateResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: CREATE_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: smsTemplateResponse.message })
      );
    }
  };

  const templateModal = {
    formTriggers,
    formInputs: getSmsTemplateFormInputs({}),
  };

  const templateEvents = {
    handleSmsTemplateSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <SmsTemplateCreateTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default SmsTemplateCreateComponent;
